import { render } from "./SocialWebsite.vue?vue&type=template&id=c63664b8"
import script from "./SocialWebsite.vue?vue&type=script&lang=js"
export * from "./SocialWebsite.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__